import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Projects', href: '#projects' },
  { label: 'About Us', href: '#about' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

const FACEBOOK_URL = 'https://www.facebook.com/marketplace/profile/100034729634288/?ref=permalink&mibextid=dXMIcH';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNav('#home'); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-lg">
            <i className="ri-building-2-fill text-white text-xl"></i>
          </div>
          <div>
            <div className={`font-black text-sm tracking-widest uppercase leading-tight ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              Allen Construction
            </div>
            <div className={`text-xs tracking-widest uppercase ${scrolled ? 'text-orange-500' : 'text-orange-300'}`}>
              Group
            </div>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className={`text-sm font-semibold tracking-wide transition-colors cursor-pointer whitespace-nowrap hover:text-orange-400 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className={`w-9 h-9 flex items-center justify-center rounded-full border transition-colors cursor-pointer ${scrolled ? 'border-gray-300 text-gray-700 hover:border-orange-500 hover:text-orange-500' : 'border-white/40 text-white hover:border-orange-400 hover:text-orange-400'}`}
          >
            <i className="ri-facebook-fill text-lg"></i>
          </a>
          <a
            href="tel:6824502501"
            className={`flex items-center gap-2 text-sm font-semibold whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-orange-500"></i>
            </div>
            (682) 450-2501
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
            className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold px-5 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Free Quote
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-2xl ${scrolled ? 'text-gray-900' : 'text-white'} ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className="text-gray-800 font-semibold py-2 border-b border-gray-100 cursor-pointer hover:text-orange-500 transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:6824502501"
            className="flex items-center gap-2 text-orange-500 font-bold py-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill"></i>
            </div>
            (682) 450-2501
          </a>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 text-gray-800 font-bold py-2 cursor-pointer hover:text-orange-500 transition-colors"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-facebook-fill text-orange-500"></i>
            </div>
            Facebook
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
            className="bg-orange-500 text-white font-bold text-center py-3 rounded-md cursor-pointer"
          >
            Get Free Quote
          </a>
        </div>
      )}
    </header>
  );
}
